import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { WarrantyFiveSvg, EverGrowingSvg, PowerBlackoutSvg } from '@/components/UI/svg/delta2max';
import NextImage from '@/components/NextImage';

export default function P() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta2max.detail');

    const Icon2 = () => {
        return (
            <div style={{ width: '52px', height: '52px' }}>
                <NextImage
                    webpSrc={require('@publicLocal/delta2max/detail/pc/sec16_icon.webp')}
                    src={require('@publicLocal/delta2max/detail/pc/sec16_icon.png')}
                />
            </div>
        );
    };

    const itemList = [
        {
            icon: <WarrantyFiveSvg />,
            slogan: t('sec16_slogan1'),
            title: t('sec16_title1'),
            desc: t('sec16_desc1'),
        },
        {
            icon: <Icon2 />,
            slogan: t('sec16_slogan2'),
            title: t('sec16_title2'),
            desc: t('sec16_desc2'),
        },
        {
            icon: <EverGrowingSvg />,
            slogan: t('sec16_slogan3'),
            title: t('sec16_title3'),
            desc: t('sec16_desc3'),
        },
        {
            icon: <PowerBlackoutSvg />,
            slogan: t('sec16_slogan4'),
            title: t('sec16_title4'),
            desc: t('sec16_desc4'),
        },
    ];

    return (
        <div
            className={`d2x-detail-P ${css.d2xDetailP} GtmModuleData-section`}
            id="d2x-detail-P"
            data-section-id={'d2x-detail-P'}
            data-section-title={t('sec16_title1')}
        >
            <div className="text-boxs">
                {itemList.map((item: any, index: number) => (
                    <div key={index} className="text-box">
                        <div className="icon">{item.icon}</div>
                        <div className="slogan">{item.slogan}</div>
                        <div className="title">{item.title}</div>
                        <div className="desc">{item.desc}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
